import { withInstall } from '../utils/index';
import _Select from './select.vue';
import _Option from './option.vue';
import _Group from './group.vue';
import './index.less';

export const TlbsSelect = withInstall(_Select);
export const TlbsOption = withInstall(_Option);
export const TlbsGroup = withInstall(_Group);

export default TlbsSelect;
